export default "__VITE_ASSET__CdbTas0s__"